/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const ReleasePage = lazyLoad(
  () => import('./index'),
  module => {
    return module.ReleasePage;
  },
);
